import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { SuccessStoryView } from "../../../Services/PublicSuccessStories";

interface SuccessStoriesListProps {
  stories: SuccessStoryView[];
  loading: boolean;
  error: string;
}

export default function SuccessStoriesList({ stories, loading, error }: SuccessStoriesListProps): ReactElement {
  if (loading) {
    return <p className="success-stories-status">Loading success stories.</p>;
  }
  if (error) {
    return <p className="success-stories-status">{error}</p>;
  }
  return (
    <div className="success-stories-list">
      {stories.map((story) => (
        <article key={story.id} className="success-stories-item">
          <div id={String(story.id)} className="success-stories-anchor" />
          <h4>{story.title}</h4>
          <p className="success-stories-copy" dangerouslySetInnerHTML={{ __html: story.bodyHtml }} />
          {story.quotesHtml ? <p className="success-stories-copy" dangerouslySetInnerHTML={{ __html: story.quotesHtml }} /> : null}
          {story.showMeta ? (
            <p className="success-stories-meta">
              <span>{story.attribution}</span>
              {story.pressLink ? (
                <a className="success-stories-more" href={story.pressLink}>
                  <span>Read More</span>
                </a>
              ) : null}
            </p>
          ) : null}
          {story.logos.length > 0 ? (
            <div className="success-stories-logos">
              {story.logos.map((logo) => (
                <Link key={`${story.id}-${logo.href}-${logo.src}`} to={logo.href}>
                  <img src={logo.src} alt="" />
                </Link>
              ))}
            </div>
          ) : null}
        </article>
      ))}
    </div>
  );
}
